import(/* webpackMode: "eager", webpackExports: ["NetpayCalculator"] */ "/app/components/netpay-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebsiteNav"] */ "/app/components/website-nav.tsx");
